import Chart from 'react-apexcharts';

// ----------------------------------------------------------------------

export { default as StyledChart } from './styles';

export { default as useChart } from './useChart';

export { default as MultiSeriesTimeChart, SERIES_PALETTE } from './MultiSeriesTimeChart';

export default Chart;
